import { ICenterUnosDataMonthlyWithStatus } from '@nkr/models/index';

const mapData = (data: ICenterUnosDataMonthlyWithStatus[]) => {
    let d = data.map(x => ({
        dataDate: x.dataDate,
        ddTxps: x.ddTxps,
        ldTxps: x.ldTxps,
        wlTotal: x.wlTotal,
        wlActive: x.wlActive,

        lda: x.lda,
        ldb: x.ldb,
        ldab: x.ldab,
        ldo: x.ldo,

        ldra: x.ldra,
        ldrb: x.ldrb,
        ldrab: x.ldrab,
        ldro: x.ldro,
    }));

    return d;
}

export default mapData;